import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from './svg-icon.component';
import { NgxsModule } from '@ngxs/store';
import { SvgIconState } from '../../store';

@NgModule({
  declarations: [SvgIconComponent],
  imports: [CommonModule, NgxsModule.forFeature([SvgIconState])],
  exports: [SvgIconComponent],
})
export class SvgIconModule {}
